import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

export interface IPostMasterDepartmentPayload {
  department: string,
  department_desc: string,
  department_cost: string,
  code_type: string,
  is_active: boolean,
  create_by: string
}

export interface IPutMasterDepartmentPayload {
  id: number,
  department: string,
  department_desc: string,
  department_cost: string,
  code_type: string,
  is_active: boolean,
  update_by: string
}

export interface IPostResponse {
  responseCode: "Succeed" | "Failed",
  responseMessage: string
}
export interface IGetMasterDepartmentData {
  id: number,
  department: string,
  department_desc: string,
  department_cost: string,
  code_type: string,
  is_active: boolean,
  create_at: string,
  create_by: string,
  update_at: string,
  update_by: string
}

export interface IGetMasterDepartmentResponse {
  lstmstdepartment: IGetMasterDepartmentData[],
}

export interface IGetMasterDepartmentCostData {
  id: number,
  code_dep: string,
  code_digit_dep: string
}

export interface IGetMasterDepartmentCostResponse {
  list_departmentcost: IGetMasterDepartmentCostData[],
}

export const url = "/v1/smplmstdepartment";

export const getMasterDepartment = async (): Promise<IGetMasterDepartmentResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
  });

  return data;
};

export const postMasterDepartment = async (
  payload: IPostMasterDepartmentPayload,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const putMasterDepartment = async (
  payload: IPutMasterDepartmentPayload,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "PUT",
    data: payload,
  });

  return data;
};

export const deleteMasterDepartment = async (
  id: number,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${id}`,
    method: "DELETE",
  });

  return data;
};

export const getMasterDepartmentCost = async (): Promise<IGetMasterDepartmentCostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}cost`,
    method: "GET",
  });

  return data;
};
